import { type ITimeQuote } from '@repo/sdk'

export const formatTime = (time: null | string | undefined): string => {
  if (!time) {
    return ''
  }

  const parts = time.split(':')

  return parts.length >= 2 ? `${parts[0]}:${parts[1]}` : time
}

export const getLoadTimeDisplay = (loadTime: ITimeQuote | undefined): string => {
  switch (loadTime?.type) {
    case '24':
      return '24h'
    case 'at':
      return `At: ${formatTime(loadTime.to)}`
    case 'between':
      return ` ${formatTime(loadTime.from)} - ${formatTime(loadTime.to)}`
    case 'by':
      return `By: ${formatTime(loadTime.from)}`
    case 'tbc':
      return 'TBC'
    default:
      return ''
  }
}
